import React from 'react';
import cn from 'classnames';
import { Nav, NavDropdown } from 'react-bootstrap';
import * as Fa from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Notification } from 'services/action';
import { useHistory } from 'react-router';

const NotificationMenu = () => {
  const Dispatch = useDispatch();
  const StateData = useSelector((state) => state?.Notification?.data);
  const IsUnreaded = useSelector((state) => state?.Notification?.unReaded);
  const History = useHistory();

  const $handleClick = (c) => {
    if (!c?.is_readed) {
      Dispatch(Notification.$markRead(c?.id));
    }

    const isShipment = c?.name.includes('tms.shipment');

    if (isShipment) {
      History.push(`/order/shipment/${c?.data?.do_id}`);
    } else {
      const isManifest = c?.name.includes('tms.manifest');
      if (isManifest) {
        History.push(`/manifest/${c?.data?.id}`);
      } else {
        History.push(`/order/${c?.data?.id}`);
      }
    }
  };

  React.useEffect(() => {
    const $onLoad = async () => {
      Dispatch(Notification.$get());
    };

    $onLoad();
  }, []);

  return (
    <li className="nav-item">
      <Nav>
        <NavDropdown
          menuVariant="light"
          className="no-carret"
          align="end"
          title={
            <div className="d-flex justify-content-center align-items-center m-0">
              <span
                className="nav-link-icon d-inline-block m-0"
                style={{
                  width: 'auto',
                  height: 'auto',
                }}
              >
                <Fa.FaBell size={18} />
              </span>
              {IsUnreaded && <span className="badge bg-red"></span>}
            </div>
          }
        >
          <div className="card notification feature-listing">
            <div className="list-group list-group-flush list-group-hoverable">
              {StateData &&
                StateData?.map((c, index) => (
                  <div
                    className={cn(
                      'list-group-item',
                      !c?.is_readed ? 'list-unreaded' : ''
                    )}
                    onClick={() => $handleClick(c)}
                    key={index}
                  >
                    <div className="row align-items-center">
                      <div className="col-auto">
                        <span
                          className={cn(
                            'status-dot d-block',
                            !c?.is_readed ? 'status-unreaded bg-success' : ''
                          )}
                        ></span>
                      </div>
                      <div className="col">
                        <h4 className="text-title">{c?.message?.title}</h4>
                        <div className="text-body">{c?.message?.body}</div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </NavDropdown>
      </Nav>
    </li>
  );
};

export default NotificationMenu;
